import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DomainAuthService } from 'src/app/private/services/domainauth.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-domain',
  imports: [SharedModule],
  templateUrl: './delete-domain.component.html',
  styleUrl: './delete-domain.component.scss'
})
export class DeleteDomainComponent {


  @Output() close = new EventEmitter<any>();
  @Input() editDomainData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api: DomainAuthService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  handleCloseDialog() {
    this.close.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete() {
    this.isLoading = true;

    const payload = {
      organization_id: this.localStorage.getOrganizationId(),
      domain: this.editDomainData.domain
    }

    this.api.deleteDomainAndEmail(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead deleted successfully' });
        this.close.emit();
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
        this.isLoading = false;
      }
    }
    );

  }

}
